import { isEmpty } from "lodash";
import GameMenu from "./GameMenu";
import SkyLayout from "./SkyLayout";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { useEffect, useMemo, useRef, useState } from "react";
import jwt_decode from "jwt-decode";
import SingleEvent from "./SingleEvent";
const Index = () => {
  const sportTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.sportTab;
  });
  const scoreAll = useContextSelector(AuthContext, (ctx) => {
    return ctx.scoreAll;
  });
  const [select, setSelect] = useState("time");
  const isSportTab = useMemo(() => sportTab, [sportTab]);
  const [data, setData] = useState([]);
  const [list, setList] = useState([]);
  const isFirstRun = useRef(true);
  const [activeFav, setActiveFav] = useState([]);
  const [loader, setLoader] = useState(false);
  const getData = async () => {
    setLoader(true);
    let { status, data } = await apiGet(apiPath.seriesList, {
      gameType: isSportTab,
      userId: !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "",
    });
console.log(data,'data')
    if (data?.success) {
      let newResult = data?.results
        ?.map((res) => {
          return res?.matchList;
        })
        .flat();

      setActiveFav(
        newResult
          ?.filter((res) => {
            return res?.isFavourite;
          })
          ?.map((res) => {
            return res?.eventId;
          })
      );
      setList(data?.results);
      setData(
        newResult.sort(
          (a, b) => new Date(a.eventDateTime) - new Date(b.eventDateTime)
        )
      );
    }
    setLoader(false);
  };
  const addToFavioute = async (
    id,
    favoriteType,
    favoriteMarketId,
    eventType
  ) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
        `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${eventType}&market=Match Odds`
    );

    if (response_users?.success) {
      if (activeFav?.includes(id)) {
        setActiveFav((prev) => {
          return prev.filter((item) => {
            return item !== id;
          });
        });
      } else {
        setActiveFav((prev) => {
          return [...prev, id];
        });
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return; // skip initial run if needed
    }

    if (isSportTab != "myfav") {
      getData();
    }
  }, [isSportTab]);

  return (
    <SkyLayout>
      <div className="mian-wrap">
        <GameMenu />
        <div className="wrap-highlight_list">
          <h3>Highlights</h3>
          <div className="sorting-wrap">
            <ul id="viewType">
              <li
                onClick={() => setSelect("time")}
                id="sortByTime"
                className={select == "time" ? "select" : ""}
              >
                by Time
              </li>
              <li
                onClick={() => setSelect("comp")}
                id="sortByCompetition"
                className={select == "comp" ? "select" : ""}
              >
                by Competition
              </li>
            </ul>
          </div>
          {select == "time" && (
            <ul id="highlightList" className="highlight-list">
              {data?.map((item) => {
                let animate = activeFav?.includes(item?.eventId);
                return (
                  <SingleEvent
                    addToFavioute={addToFavioute}
                    scoreAll={scoreAll}
                    item={item}
                    animate={animate}
                  />
                );
              })}
            </ul>
          )}{" "}
          {select == "comp" && (
            <ul id="highlightList" className="highlight-list">
              {list?.map((item) => {
                return (
                  <div
                    id="AsiaCup"
                    className="sortinglist-wrap"
                    style={{ display: "block" }}
                  >
                    <h4>{item?.seriesName}</h4>
                    <ul id="AsiaCupBoard" className="highlight-list">
                      {item?.matchList?.map((res) => {
                        return (
                          <SingleEvent
                            addToFavioute={addToFavioute}
                            item={res}
                            animate={activeFav?.includes(res?.eventId)}
                            scoreAll={scoreAll}
                          />
                        );
                      })}
                    </ul>
                  </div>
                );
              })}
            </ul>
          )}
        </div>
        <div className="footer-kv">
          <a
            href="#" onClick={(e) => e.preventDefault()}
            id="sportradarHighlightEntrance"
            className="entrance"
            style={{ cursor: "pointer" }}
            neua="BetRadar Banner"
          >
            <img
              src={require("../../assets/images/kv-virtual-cricket-m.jpg")}
              style={{ width: "100%" }}
              alt
              draggable="false"
            />
          </a>
        </div>
      </div>
    </SkyLayout>
  );
};

export default Index;
